import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Font, FontGrey } from "../../../utils/Font";
import "../../Products/Style.css";

const Deliveries = () => {
  return (
    <div>
      <div className="container mt-5">
        <Font title="Soothe & Tie Deliveries" />

        <div className="md:flex items-start gap-14 mt-7 mx-2">
          <Delive title={"Total Income"} amount="₦ 369,420" />
          <Delive title={"Total Orders"} amount="2,567" item />
        </div>

        <div>
          {/* Pending deliveries */}
          <div className="mt-5 my-3">
            <FontGrey title={"Pending deliveries"} />
            {/* pending Product List */}
            <div className="flex  px-2 py-4 overflow-x-scroll no-scrollbar scroll-smooth snap-mandatory snap-x ">
              <PendingProduct />
            </div>
          </div>
          {/* Completed deliveries */}
          <div className="mt-5 my-3">
            <FontGrey title={"Completed deliveries"} />
            {/* Completed deliveries*/}
            <div className="flex  px-2 py-4 overflow-x-scroll no-scrollbar scroll-smooth snap-mandatory snap-x ">
              <PendingProduct />
            </div>
          </div>
          {/* Delivery History */}
          <div className="mt-5 my-3">
            <FontGrey title={"Delivery History"} />
            {/* Delivery History*/}
            <div className="flex  px-2 py-4 overflow-x-scroll no-scrollbar scroll-smooth snap-mandatory snap-x ">
              fghjkl
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function Delive({ title, amount, item }) {
  const [state, setstate] = useState("osos");
  return (
    <div className="w-full md:w-[40%] h-48 border-[#CCE5FF] border-2 rounded-lg flex items-start justify-start flex-col p-4 my-3 cursor-pointer bg-[#ffff] hover:bg-[#CCE5FF] md:my-0 hover:scale-105 hover:shadow-sm  transition duration-700 ease-in-out">
      <FontGrey title={title} />
      <div className="font-workSans mt-3 text-[40px] flex gap-x-5">
        <Font title={amount} />
        {item ? <FontGrey title="items" /> : null}
      </div>
    </div>
  );
}

function PendingProduct() {
  return (
    <>
      <div className="w-90 flex gap-x-3">
        {[...Array(5)].map((elem, index) => (
          <div
            key={index}
            className="h-[400px] w-[300px] bg-white  ring-[#CCE5FF] ring-2 shadow-md rounded overflow-hidden"
          >
            <div className="w-full h-[50%] overflow-hidden ">
              <img
                src="/Images/DeliverManIma.svg"
                alt=""
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-full h-[50%] flex items-center justify-center">
              <div className="px-3 py-4 w-[70%] font-workSans text-xl">
                <p>Sea Blue Armenian Three Piece Suit...</p>
                <div className="my-2">
                  {[...Array(5)].map((elem, i) => (
                    <i
                      key={i}
                      className="bi bi-star-fill text-xl text-[#FF4C3B]"
                    ></i>
                  ))}
                </div>
                <div className="text-2xl font-workSans font-semibold">
                  ₦ 75,000
                </div>
              </div>

              <div className="w-[40%] flex just items-center">
                <img src="/Images/chart.svg" alt="" className="w-full" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
export default Deliveries;
